export default "__VITE_ASSET__DWyGiPXA__"